<app-top-notification />

<header-container [isWebApp]="isWebApp" />

<div class="section-apollo">
    <router-outlet></router-outlet>
</div>

@defer {
    @if (hideFooter$$() === false) {
        <div class="footer-apollo p-relative"><cms-render-lazy [slug]="slugFooter"></cms-render-lazy></div>
    }
} @placeholder {
    <div class="ptr-160 pbr-160 bg-black"></div>
}

@if (menuData$ | async; as menuData) {
    <header-menu [direction]="menuData.direction" [categories]="menuData.categories"></header-menu>
}
